module.exports = __webpack_public_path__ + "static/media/workstep1.1a0c638f.webp";